import React from 'react';

import { useTranslation } from 'react-i18next';
import { Button } from '@bringg/react-components';

import styles from './columns-labels-header.module.scss';

interface ColumnsLabelsHeaderProps {
	isDirty: boolean;
	isSaving: boolean;
	onSave: () => void;
}

const ColumnsLabelsHeader: React.FC<ColumnsLabelsHeaderProps> = ({ isDirty, isSaving, onSave }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.columnsLabelsHeader}>
			<div>
				<div className={styles.title}>{t('WEB_USER_INTERFACE.COLUMN_LABELS.TITLE')}</div>
				<div className={styles.description}>{t('WEB_USER_INTERFACE.COLUMN_LABELS.DESCRIPTION')}</div>
			</div>
			<Button
				type="primary"
				disabled={!isDirty || isSaving}
				onClick={onSave}
				data-test-id="column-labels-save-button"
			>
				{t('WEB_USER_INTERFACE.COLUMN_LABELS.SAVE_CHANGES')}
			</Button>
		</div>
	);
};

export default ColumnsLabelsHeader;
